import FurnitureTrolleyIconPath from "@ingka/ssr-icon/paths/furniture-trolley";

export default FurnitureTrolleyIconPath;
